import { AppNotification } from "../interfaces/AppNotification";
import { atom } from "recoil";

const notificationsState = atom({
  key: "notifications",
  default: [] as AppNotification[],
});

export default notificationsState;
